<template>
  <Panel class="intro-y" :title="$t('text.performance')">
    <div class="overflow-x-auto -m-5 text-sm">
      <OfficerPerformanceTable
        :loading="isLoading"
        :rows="officerPerformanceList"
        :columns="columns"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        @delete="confirmRemoval"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
      />
    </div>
  </Panel>
</template>

<script>
import { mapGetters } from 'vuex';
import { OFFICER_PERFORMANCE_LIST_REQUEST } from '@/store/actions/officer';
import dataListMixin from '@/mixins/dataListMixin';
import Panel from '@/components/ui/Panel';
import OfficerPerformanceTable from '@/components/officer/OfficerPerformanceTable';

export default {
  mixins: [dataListMixin],

  props: {
    officer: Object,
  },

  data() {
    return {
      storeActionListRequest: OFFICER_PERFORMANCE_LIST_REQUEST,
      columns: [
        {
          label: this.$t('text.date'),
          field: 'performanceDate',
          sortable: true,
        },
        {
          label: this.$t('text.loanPackage'),
          field: 'loanPackage',
          sortable: true,
        },
        {
          label: this.$t('short.activeLoans'),
          field: 'activeLoanCount',
          sortable: true,
        },
        {
          label: this.$t('short.loanOverdue'),
          field: 'overdueLoanCount',
          sortable: true,
        },
        {
          label: this.$t('short.haveDeadline'),
          field: 'reminderLoanCount',
          sortable: true,
        },
        {
          label: this.$t('short.worked'),
          field: 'workedLoanCount',
          sortable: true,
        },
        {
          label: this.$t('short.contracted'),
          field: 'contractedLoanCount',
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters([
      'officerPerformanceList',
      'officerPerformanceListStatus',
      'officerPerformanceListMeta',
    ]),
    isLoading() {
      return this.officerPerformanceListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[officerId]`] = this.officer.id;
    },

    setPaginationValues() {
      this.totalRecords = this.officerPerformanceListMeta
        ? this.officerPerformanceListMeta.total
        : 1;
      this.page = this.officerPerformanceListMeta.currentPage;
      this.totalPage = this.officerPerformanceListMeta.lastPage;
    },
  },

  components: {
    Panel,
    OfficerPerformanceTable,
  },
};
</script>
